module.exports = __webpack_public_path__ + "static/media/DOCX.5263e224.svg";